
function getTaxAmount(customerLocation, subtotal) {
  // returns the total amount of taxes to be paid, based on 
  // province/state
  
  let taxRate;
  let taxType;
  switch (customerLocation) {
    case "Alberta":
    case "Northwest Territories":
    case "Nunavut":
    case "Yukon":
      taxRate = 0.05;
      taxType = "(GST)";
      break;
    case "British Columbia":
    case "Manitoba":
      taxRate = 0.12;
      taxType = "(PST, GST)";
      break;
    case "New Brunswick":
    case "Newfoundland and Labrador":
    case "Nova Scotia":
    case "Prince Edward Island":
      taxRate = 0.15;
      taxType = "(HST)";
      break;
    case "Ontario":
      taxRate = 0.13;
      taxType = "(HST)";
      break;
    case "Quebec":
      taxRate = 0.14975;
      taxType = "(GST, QST)";
      break;
    case "Saskatchewan":
      taxRate = 0.11;
      taxType = "(GST, PST)";
      break;

    case "Colorado":
      taxRate = 0.029;
      taxType = "(Sales Tax)";
      break;
    case "Alabama":
    case "Georgia":
    case "Hawaii":
    case "New York":
    case "Wyoming":
      taxRate = 0.04;
      taxType = "(Sales Tax)";
      break;
    case "Missouri":
      taxRate = 0.0423;
      taxType = "(Sales Tax)";
      break;
    case "Louisiana":
      taxRate = 0.0445;
      taxType = "(Sales Tax)";
      break;
    case "Oklahoma":
    case "South Dakota":
      taxRate = 0.045;
      taxType = "(Sales Tax)";
      break;
    case "North Carolina":
      taxRate = 0.0475;
      taxType = "(Sales Tax)";
      break;
    case "North Dakota":
    case "Wisconsin":
      taxRate = 0.05;
      taxType = "(Sales Tax)";
      break;
    case "New Mexico":
      taxRate = 0.0513;
      taxType = "(Sales Tax)";
      break;
    case "Virginia":
      taxRate = 0.053;
      taxType = "(Sales Tax)";
      break;
    case "Maine":
    case "Nebraska":
      taxRate = 0.055;
      taxType = "(Sales Tax)";
      break;
    case "Arizona":
      taxRate = 0.056;
      taxType = "(Sales Tax)";
      break;
    case "Ohio":
      taxRate = 0.0575;
      taxType = "(Sales Tax)";
      break;
    case "District of Columbia":
    case "Florid":
    case "Idaho":
    case "Iowa":
    case "Kentucky":
    case "Maryland":
    case "Michigan":
    case "Pennsylvania":
    case "South Carolina":
    case "Vermont":
    case "West Virginia":
      taxRate = 0.06;
      taxType = "(Sales Tax)";
      break;

    case "Utah":
      taxRate = 0.061;
      taxType = "(Sales Tax)";
      break;
    case "Illinois":
    case "Massachusetts":
    case "Texas":
      taxRate = 0.0625;
      taxType = "(Sales Tax)";
      break;
    case "Connecticut":
      taxRate = 0.0635;
      taxType = "(Sales Tax)";
      break;
    case "Arkansas":
    case "Kansas":
    case "Washington":
      taxRate = 0.065;
      taxType = "(Sales Tax)";
      break;
    case "New Jersey":
      taxRate = 0.063;
      taxType = "(Sales Tax)";
      break;
    case "Nevada":
      taxRate = 0.0685;
      taxType = "(Sales Tax)";
      break;
    case "Minnesota":
      taxRate = 0.0688;
      taxType = "(Sales Tax)";
      break;
    case "Indiana":
    case "Mississippi":
    case "Rhode Island":
    case "Tennessee":
      taxRate = 0.07;
      taxType = "(Sales Tax)";
      break;
    case "California":
      taxRate = 0.0725;
      taxType = "(Sales Tax)";
      break;
    default:
      taxRate = 0;
      taxType = "(Sales Tax)";
      break;
  }

  // Calculate tax amount
  const taxAmount = subtotal * taxRate;
  return {taxType, taxAmount};
}

export default getTaxAmount;
